import graphql from "babel-plugin-relay/macro";

export const documentChangesFromPreviousVersionQuery = graphql`
  query documentChangesFromPreviousVersionQuery($documentPk: Int!) {
    documentChangesFromPreviousVersion(documentId: $documentPk) {
      taskId
    }
  }
`;

export default documentChangesFromPreviousVersionQuery;
